module.exports = require('./useComponentSize')
